// extracted by mini-css-extract-plugin
module.exports = {"parent":"parent_3UYar","children":"children_2uXKD"};